module.exports = __webpack_public_path__ + "img/treppe.eda727b4.webp";